// React
import { useCallback } from 'react';

// Kendo
import { Editor as KendoEditor, EditorTools } from '@progress/kendo-react-editor';

const {
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Subscript,
    Superscript,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Indent,
    Outdent,
    OrderedList,
    UnorderedList,
    Undo,
    Redo,
    FontSize,
    FontName,
    FormatBlock,
    Link,
    Unlink,
    InsertImage,
    ViewHtml,
    InsertTable,
    AddRowBefore,
    AddRowAfter,
    AddColumnBefore,
    AddColumnAfter,
    DeleteRow,
    DeleteColumn,
    DeleteTable,
    MergeCells,
    SplitCell
} = EditorTools;

const Editor = (fieldRenderProps) => {
    const { value, onChange, onLabel, offLabel, ...others } = fieldRenderProps;

    const handleChange = useCallback((event) => {
        onChange({
            value: event.html
        });
    }, [ onChange ]);

    return (
        <KendoEditor
            tools={[
                [ Bold, Italic, Underline, Strikethrough ],
                [ AlignLeft, AlignCenter, AlignRight, AlignJustify ],
            ]}
            { ...others }
            defaultContent={ value ? value : undefined }
            onChange={ handleChange }
        />
    )
};

export default Editor;
